const modelTypes = [{
  key: 'printReady',
  labelKey: 'print_ready',
}, {
  key: 'pbr',
  labelKey: 'pbr',
}, {
  key: 'animated',
  labelKey: 'animated',
}, {
  key: 'rigged',
  labelKey: 'rigged',
}, {
  key: 'lowPoly',
  labelKey: 'low_poly',
}]

export default modelTypes
